import React from 'react';
import PropTypes from 'prop-types';

import assets from 'marketing-website/configs/pages/account-locked/assets';

import Align from '@marvelapp/marvel-ui/align';
import Button from '@marvelapp/marvel-ui/button';
import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import Heading from '@marvelapp/marvel-ui/heading';
import Image from 'marketing-website/components/modules/Image';
import Link from '@marvelapp/marvel-ui/link';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Position from '@marvelapp/marvel-ui/position';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import Spacing from '@marvelapp/marvel-ui/spacing';

import Page from 'marketing-website/components/modules/Page';
import LandingPagesWrap from 'marketing-website/components/modules/LandingPagesWrap';

const meta = {
  title: 'Team - your account has been locked',
  meta: [
    {
      name: 'description',
      content: 'Contact our support team to get access to your account.',
    },
    {
      name: 'keywords',
      content: 'enterprise design, design thinking, design thinking process',
    },
  ],
  header: false,
  footer: false,
};

export default function AccountLocked(history) {
  return (
    <Page {...meta}>
      <Position type="absolute" location="all">
        <Align type="middle">
          <div id="enterprise-form">
            <LandingPagesWrap history={history} showBackButton={false}>
              <div className="marginTop-l">
                <Spacing size="m" position="topBottom" type="padding">
                  <PageWrap size="m" maxWidth={840}>
                    <Grid columns={12} size="xl" alignItems="center">
                      <GridItem columnSpan={12} columnSpanM={6}>
                        <Align type="center" typeM="left">
                          <Spacing type="margin" size="m" position="top" />
                          <MaxWidth value={280}>
                            <Heading size="xxxl" weight="bold">
                              Your Team account has expired
                            </Heading>
                          </MaxWidth>
                          <Spacing type="margin" size="m" position="top">
                            <MaxWidth value={280}>
                              <Paragraph size="m" color="slate">
                                Speak to the support team to update your
                                subscription and reactivate your account.
                              </Paragraph>
                            </MaxWidth>
                          </Spacing>
                          <Spacing type="margin" size="m" position="top">
                            <Link
                              type="blue"
                              url="mailto:help@marvelapp.com"
                              target="_blank"
                            >
                              <Button
                                size="medium"
                                color="white"
                                hover="green"
                                background="blue"
                              >
                                Contact Support
                              </Button>
                            </Link>
                          </Spacing>
                        </Align>
                      </GridItem>
                      <GridItem columnSpan={12} columnSpanM={6}>
                        <Align type="center">
                          <Spacing size="m" position="top" type="margin">
                            <Image
                              alt="Trial expired, contact sales for more info"
                              maxWidth={assets.illustration.maxWidth}
                              src={assets.illustration.src}
                              hasShadow={false}
                              useImageTag
                            />
                          </Spacing>
                        </Align>
                      </GridItem>
                    </Grid>
                  </PageWrap>
                </Spacing>
              </div>
            </LandingPagesWrap>
          </div>
        </Align>
      </Position>
    </Page>
  );
}

AccountLocked.propTypes = {
  history: PropTypes.object.isRequired,
};

AccountLocked.defaultProps = {};



// WEBPACK FOOTER //
// ./src/pages/team-account-expired/index.js